import React from "react";
import Ajax, { domain } from "../../managment/ajax/Ajax";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      invalidLogin: false,
      networkError: false,
      loginSuccess: false,
      processing: false,
    };

    this.submitLogin = this.submitLogin.bind(this);
  }

  async submitLogin(event) {
    event.preventDefault();
    this.setState({ processing: true });

    let setUser = this.props.setUser;

    let data = {
      username: this.state.username,
      password: this.state.password,
    };
    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/token-auth/",
      data
    );

    if (response) {
      if (!response.ok) {
        this.setState({
          invalidLogin: true,
          processing: false,
        });
        return;
      }

      localStorage.setItem("token", response["token"]);
      localStorage.setItem("user", JSON.stringify(response["user"]));

      await this.setState({ processing: false, loginSuccess: true });

      setTimeout(function () {
        setUser(response.user);
      }, 1000);
    } else {
      this.setState({
        networkError: true,
        processing: false,
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.invalidLogin ? (
          <div className="message is-danger animated fadeIn">
            <div className="message-body has-text-centered">
              <span className="zmdi zmdi-close-circle mr-2"></span> Wrong
              username or password!
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {this.state.networkError ? (
          <div className="message is-danger animated fadeIn">
            <div className="message-body has-text-centered">
              <span className="zmdi zmdi-close-circle mr-2"></span> Network
              Error. Please Try again!
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {this.state.loginSuccess ? (
          <div className="message is-success animated fadeIn">
            <div className="message-body has-text-centered">
              <span className="zmdi zmdi-check-circle mr-2"></span> Login
              Successful!
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <form action="#" onSubmit={this.submitLogin}>
          <div className="has-text-centered field">
            <strong> Please login</strong>
          </div>
          <div className="field">
            <input
              value={this.state.username}
              onChange={(event) => {
                this.setState({
                  username: event.target.value,
                });
              }}
              required
              name="email"
              placeholder="email"
              type="email"
              className="input"
            />
          </div>

          <div className="field">
            <input
              alue={this.state.password}
              onChange={(event) => {
                this.setState({
                  password: event.target.value,
                });
              }}
              required
              name="password"
              placeholder="password"
              type="password"
              className="input"
            />
          </div>

          <div className="field">
            <button className="button is-info is-fullwidth">Login</button>
          </div>
          <div className="field">
            I don't have an account.{" "}
            <span>
              <a
                href="#!"
                onClick={() => {
                  this.props.toggleSigupLogin(false);
                }}
              >
                Create Account
              </a>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

export default Login;
